var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakeLogoFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9178 13.1615C32.0096 12.0601 29.6588 12.0601 27.7506 13.1615L18.5 18.5017L27.7506 23.842C29.6588 24.9437 32.0096 24.9437 33.9178 23.842C35.826 22.7406 37.0011 20.705 37.0011 18.5017C37.0011 16.2988 35.826 14.2629 33.9178 13.1615Z",
    fill: "#F2F2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08361 13.1615C1.1754 14.2629 0 16.2988 0 18.5017C0 20.705 1.1754 22.7406 3.08361 23.842C4.99157 24.9437 7.34262 24.9437 9.25058 23.842L18.5014 18.5017L9.25058 13.1615C7.34262 12.0601 4.99157 12.0601 3.08361 13.1615Z",
    fill: "#F2F2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1621 33.9171C14.2639 35.8248 16.2998 37.0001 18.5031 37.0001C20.7065 37.0001 22.7424 35.8248 23.8439 33.9171C24.9457 32.0091 24.9457 29.6586 23.8439 27.7506L18.5031 18.501L13.1621 27.7506C12.0605 29.6586 12.0605 32.0091 13.1621 33.9171Z",
    fill: "#F2F2F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8439 3.08322C22.7424 1.17525 20.7065 0 18.5031 0C16.2998 0 14.2639 1.17525 13.1621 3.08322C12.0605 4.99094 12.0605 7.34169 13.1621 9.24941L18.5031 18.4988L23.8439 9.24941C24.9457 7.34169 24.9457 4.99094 23.8439 3.08322Z",
    fill: "#F2F2F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeLogoFilled);
export default __webpack_public_path__ + "static/media/stake-logo-filled.697a0838.svg";
export { ForwardRef as ReactComponent };